import {
  css,
  EmotionComponent,
  minusOnePx,
  styled,
  themeGet,
} from "@catchoftheday/theme";

const breakpoints = (props) => ({
  xs: `@media screen and (max-width: ${minusOnePx(
    themeGet("breakpoints.0")(props)
  )})`,
  sm: `@media screen and (min-width: ${themeGet("breakpoints.0")(props)})
                     and (max-width: ${minusOnePx(
                       themeGet("breakpoints.1")(props)
                     )})`,
  md: `@media screen and (min-width: ${themeGet("breakpoints.1")(props)})
                     and (max-width: ${minusOnePx(
                       themeGet("breakpoints.2")(props)
                     )})`,
  lg: `@media screen and (min-width: ${themeGet("breakpoints.2")(props)})
  and (max-width: ${minusOnePx(themeGet("breakpoints.3")(props))})`,
  xl: `@media screen and (min-width: ${themeGet("breakpoints.3")(props)})`,
});

const hidden = (key) => (props) =>
  props[key] &&
  css`
    ${breakpoints(props)[key]} {
      display: none;
    }
  `;

export type HideProps = {
  /** Hide content when viewport < xs  */
  xs?: boolean;
  /** Hide content when viewport >= xs and < sm  */
  sm?: boolean;
  /** Hide content when viewport >= sm and < md  */
  md?: boolean;
  /** Hide content when viewport >= md and < lg  */
  lg?: boolean;
  /** Hide content when viewport > lg */
  xl?: boolean;
  children?: React.ReactNode;
};

export const Hide: EmotionComponent<HideProps> = styled.div`
  ${hidden("xs")}
  ${hidden("sm")}
  ${hidden("md")}
  ${hidden("lg")}
  ${hidden("xl")}
`;

Hide.displayName = "Hide";

export default Hide;
